export default __webpack_public_path__ + "static/slide1-09de469c7d37249f8a745e644c7f2d81.png";